import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import "./ErrorBoundary.css";
class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasErrors: false };
    }
    static getDerivedStateFromError() {
        return { hasErrors: true };
    }
    componentDidCatch(error, errorInfo) {
        console.error("An error occurred:", error, errorInfo);
    }
    render() {
        if (this.state.hasErrors) {
            return (_jsx("div", Object.assign({ className: "error-boundary_error-msg" }, { children: "An Error occurred trying to render this component." })));
        }
        return this.props.children;
    }
}
export default ErrorBoundary;
